import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Aperçu fidèle de l'e-mail (rendu par le serveur), mis à jour à la saisie.
export const EmailPreview = ({ draft, height = 420 }) => {
  const [html, setHtml] = useState("");
  const [subject, setSubject] = useState("");
  useEffect(() => {
    const t = setTimeout(() => {
      api.post("/admin/email-campaigns/preview-html", draft).then((r) => { setHtml(r.data.html); setSubject(r.data.subject); }).catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [draft]);
  return (
    <div className="overflow-hidden rounded-xl border border-white/10" data-testid="email-preview">
      <div className="truncate border-b border-white/10 bg-white/5 px-3 py-2 text-xs text-muted-foreground">Objet : <span className="text-white">{subject}</span></div>
      <iframe title="Aperçu e-mail" srcDoc={html} className="w-full bg-[#0b0b0d]" style={{ height }} sandbox="" />
    </div>
  );
};
